<template>
    <div class="filter-aside">
        <button
            v-if="ridingschoolStore.searchUrl !== null && mq"
            type="button"
            class="btn-clear"
            @click="clearFilters()">
            Wis filters
        </button>
        <div class="filter-group" v-for="item in filters" :key="item.Id">
            <header class="filter-group__header">
                {{ item.Title }}
            </header>
            <div class="filter-group__list">
                <component
                    :is="componentMap.get(item.Type)"
                    :filters="item.Filters"
                    :alias="item.Alias">
                </component>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
// Types
import type { Component } from 'vue';

// Store
import { useRidingschoolStore } from '../store/ridingschool.store';

// Composables
import { useMediaQuery } from '../../../composables/useMediaQuery';

// Components
import checkbox from '../../../components/forms/checkboxList.component.vue';
import radio from '../../../components/forms/radioList.component.vue';
import range from '../../../components/forms/rangeSlider.component.vue';

const ridingschoolStore = useRidingschoolStore();

const filters = ridingschoolStore.filters;

const componentMap = new Map<string, Component>([
    ['radio', radio],
    ['checkbox', checkbox],
    ['range', range],
]);

const mq = useMediaQuery('(min-width: 1024px)');

function clearFilters() {
    if (ridingschoolStore.searchUrl !== null) {
        ridingschoolStore.clearSearchParams();
    }
}
</script>
